import { render, staticRenderFns } from "./MyAboutUs.vue?vue&type=template&id=7cd9985a&scoped=true"
import script from "./MyAboutUs.vue?vue&type=script&lang=js"
export * from "./MyAboutUs.vue?vue&type=script&lang=js"
import style0 from "./MyAboutUs.vue?vue&type=style&index=0&id=7cd9985a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd9985a",
  null
  
)

export default component.exports